<template>
    <div v-html="displayText"></div>
</template>
<script>
export default {
    data() {
        return {
            displayText: ''
        };
    },
    beforeMount() {
        const selectedItem = this.params.teamRegions.find((item) => item.teamRegionId === this.params.value);
        this.displayText = selectedItem
            ? `${'&nbsp;'.repeat(selectedItem.level * 3)}${selectedItem.name}`
            : this.params.value;
    }
};
</script>
